import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';

/**
 * Componente principal del módulo Informes Rechazados.
 * Muestra las sub-opciones: Orientaciones Programadas y No Programadas.
 *
 * Legacy: Menú lateral con opciones "Orientaciones Programadas" y "Orientaciones No Programadas"
 * @author Sura - Migración GWT a Angular
 */
@Component({
  selector: 'app-informes-rechazados',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterOutlet, CardModule],
  template: `
    <div class="p-6 max-w-7xl mx-auto">
      <!-- Header -->
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-2">
          📋 Informes Rechazados
        </h1>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Consulta de cumplimientos rechazados por tipo de orientación
        </p>
      </div>

      <!-- Sub-opciones como cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <a
          routerLink="orientaciones-programadas"
          class="block p-6 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-100 dark:hover:bg-blue-900/50 rounded-lg border border-blue-200 dark:border-blue-700 transition-colors"
        >
          <div class="text-center">
            <div class="text-3xl mb-2">📅</div>
            <h3 class="font-semibold text-blue-800 dark:text-blue-300">
              Orientaciones Programadas
            </h3>
            <p class="text-sm text-blue-600 dark:text-blue-400 mt-2">
              Consulta de cumplimientos para orientaciones con programación
            </p>
          </div>
        </a>
        <a
          routerLink="orientaciones-no-programadas"
          class="block p-6 bg-yellow-50 dark:bg-yellow-900/30 hover:bg-yellow-100 dark:hover:bg-yellow-900/50 rounded-lg border border-yellow-200 dark:border-yellow-700 transition-colors"
        >
          <div class="text-center">
            <div class="text-3xl mb-2">📝</div>
            <h3 class="font-semibold text-yellow-800 dark:text-yellow-300">
              Orientaciones No Programadas
            </h3>
            <p class="text-sm text-yellow-600 dark:text-yellow-400 mt-2">
              Consulta de cumplimientos para orientaciones sin programación
            </p>
          </div>
        </a>
      </div>

      <!-- Router outlet para cargar el formulario de consulta -->
      <router-outlet></router-outlet>
    </div>
  `
})
export class InformesRechazadosComponent {}
